import React from 'react';
import '../styles/global.scss';
import Layout from '../components/Layout/Layout';
var Blog = function Blog() { return /*#__PURE__*/ React.createElement(React.Fragment, null, "Blog Page"); };
Blog.Layout = Layout;
export default Blog;
